export const isDeliveryChargeOptionDisabled = (deliveryMode, chargeValue) => {
    const isBargeBlocked =
        deliveryMode === 'barge' &&
        (chargeValue === 'trucking_fee_product_wise' || chargeValue === 'trucking_fee_lump_sum');
    const isTruckBlocked =
        deliveryMode === 'truck' &&
        (chargeValue === 'barging_fee_product_wise' || chargeValue === 'barging_fee_lump_sum');
    return isBargeBlocked || isTruckBlocked;
};

export const isProductWiseChargeType = (chargeType) =>
    chargeType === 'brokerage_fee_product_wise' ||
    chargeType === 'barging_fee_product_wise' ||
    chargeType === 'trucking_fee_product_wise';

export const getChargeProductFieldValue = (charge) => {
    if (!isProductWiseChargeType(charge.charge_type)) {
        return '';
    }
    return charge.product_ulid;
};

export const getAdditionalChargeRowKey = (addCharges) =>
    addCharges.rowKey ||
    [addCharges.charge_type, addCharges.product_ulid, addCharges.other_charge_name, addCharges.charge_amount].join('|');

let additionalChargeRowSeq = 0;
export const nextAdditionalChargeRowKey = () => `additional-charge-${++additionalChargeRowSeq}`;

export const getMatchingProductForCharge = (productTypes, product, platformRole) =>
    productTypes?.find((type) =>
        platformRole !== 'broker' ? type.ulid === product.type : product.product_ulid === type.ulid
    );

export const getChargeProductOptionValue = (matchingProduct, platformRole) =>
    platformRole !== 'broker' ? matchingProduct?.ulid : matchingProduct?.product_ulid;
